<div id="layout" class="theme-cyan">
  <app-project-leftmenu></app-project-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="avatar sm">
                  <a [routerLink]="['/app-project-overview']" href="javascript:void(0)" title="" class="link"><i
                      class="zmdi zmdi-arrow-left zmdi-hc-lg"></i></a>
                </div>
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Projects Detals</h5>
                  </div>
                  <small class="text-truncate text-muted">Description text here...</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <a href="javascript:void(0)" class="btn btn-sm btn-default">Edits</a>
              <a href="javascript:void(0)" class="btn btn-sm btn-warning">Report contact</a>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row">
            <div class="col-lg-9 col-md-12">
              <div class="card mb-3">
                <div class="card-header">
                  <h6 class="card-title mb-1 fw-bold">Ergonomic real-time adapter</h6>
                  <span class="text-muted">Status: Active</span>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-5">
                      <dl class="dl-horizontal">
                        <dt>Created by:</dt>
                        <dd>Alex Smith</dd>
                        <dt>Messages:</dt>
                        <dd>162</dd>
                        <dt>Client:</dt>
                        <dd><a href="javascript:void(0)"> ZMK Tech LLP.</a></dd>
                        <dt>Version:</dt>
                        <dd>v1.2.0</dd>
                      </dl>
                    </div>
                    <div class="col-lg-7">
                      <dl class="dl-horizontal">
                        <dt>Last Updated:</dt>
                        <dd>16.08.2020 12:15:57</dd>
                        <dt>Created:</dt>
                        <dd>10.07.2020 23:36:57</dd>
                        <dt>Participants:</dt>
                        <div class="avatar-list avatar-list-stacked mt-1">
                          <img class="avatar sm rounded" src="../assets/images/xs/avatar5.jpg" data-bs-toggle="tooltip"
                            title="" data-original-title="Sean">
                          <img class="avatar sm rounded ml-1" src="../assets/images/xs/avatar6.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Martin">
                          <img class="avatar sm rounded ml-1" src="../assets/images/xs/avatar1.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Terry">
                          <img class="avatar sm rounded ml-1" src="../assets/images/xs/avatar4.jpg"
                            data-bs-toggle="tooltip" title="" data-original-title="Michelle">
                        </div>
                      </dl>
                    </div>
                  </div>
                  <h6>Completed:</h6>
                  <div>
                    <div class="progress">
                      <div style="width: 60%;" class="progress-bar"></div>
                    </div>
                    <small>Project completed in <strong>60%</strong>. Remaining close the project, sign a contract and
                      invoice.</small>
                  </div>
                </div>
              </div>

              <!-- nav tab  -->
              <ul class="nav nav-tabs tab-custom tab-sm border-0 mb-1" role="tablist">
                <li class="nav-item">
                  <a class="nav-link border-0 active" href="javascript:void(0)" (click)="onMenuTab('1')"
                    [ngClass]="{'active': listTab}">Users
                    messages</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link border-0" href="javascript:void(0)" (click)="onMenuTab('2')"
                    [ngClass]="{'active': gridTab}">Last activity</a>
                </li>
              </ul>
              <div class="tab-content mb-3">
                <!-- Project messages -->
                <div class="tab-pane active" id="Users-messages" [ngClass]="{'show active': listTab}">
                  <div class="card">
                    <div class="card-body">
                      <div class="mb-4">
                        <div class="form-group">
                          <div class="input-group">
                            <textarea rows="3" class="form-control" placeholder="Enter Messages"></textarea>
                          </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-primary">Send</button>
                        <button type="button" class="btn btn-sm btn-secondary ml-1">Add files</button>
                      </div>
                      <div class="feed-element mb-3">
                        <div class="media">
                          <a href="javascript:void(0)" class="me-3">
                            <img alt="image" class="avatar sm rounded-circle" src="../assets/images/xs/avatar1.jpg">
                          </a>
                          <div class="media-body">
                            <small class="float-md-right">2h ago</small>
                            <span class="fw-bold">Mark Johnson</span> posted message on <span class="fw-bold">Monica
                              Smith</span> site. <br>
                            <small class="text-muted">Today 2:10 pm - 12.06.2020</small>
                            <div class="mt-2">
                              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                              been the industry's standard dummy text ever since the 1500s.
                              Over the years, sometimes by accident, sometimes on purpose (injected humour and the
                              like).
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="feed-element mb-3">
                        <div class="media">
                          <a href="javascript:void(0)" class="me-3">
                            <img alt="image" class="avatar sm rounded-circle" src="../assets/images/xs/avatar2.jpg">
                          </a>
                          <div class="media-body">
                            <small class="float-md-right">2h ago</small>
                            <span class="fw-bold">Janet Rosowski</span> add 1 photo on <span class="fw-bold">Monica
                              Smith</span>. <br>
                            <small class="text-muted">2 days ago at 8:30am</small>
                          </div>
                        </div>
                      </div>
                      <div class="feed-element mb-3">
                        <div class="media">
                          <a href="javascript:void(0)" class="me-3">
                            <img alt="image" class="avatar sm rounded-circle" src="../assets/images/xs/avatar3.jpg">
                          </a>
                          <div class="media-body">
                            <small class="float-md-right">5h ago</small>
                            <span class="fw-bold">Chris Johnatan Overtunk</span> started following <span
                              class="fw-bold">Monica Smith</span>. <br>
                            <small class="text-muted">Yesterday 1:21 pm - 11.06.2020</small>
                            <div class="actions">
                              <a class="btn btn-link"><i class="zmdi zmdi-thumb-up"></i> Like </a>
                              <a class="btn btn-link"><i class="zmdi zmdi-favorite"></i> Love</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="feed-element mb-3">
                        <div class="media">
                          <a href="javascript:void(0)" class="me-3">
                            <img alt="image" class="avatar sm rounded-circle" src="../assets/images/xs/avatar4.jpg">
                          </a>
                          <div class="media-body">
                            <small class="float-md-right">2h ago</small>
                            <span class="fw-bold">Kim Smith</span> posted message on <span class="fw-bold">Monica
                              Smith</span> site. <br>
                            <small class="text-muted">Yesterday 5:20 pm - 12.06.2020</small>
                            <div class="mt-2">
                              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                              been the industry's standard dummy text ever since the 1500s.
                              Over the years, sometimes by accident, sometimes on purpose (injected humour and the
                              like).
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="feed-element mb-3">
                        <div class="media">
                          <a href="javascript:void(0)" class="me-3">
                            <img alt="image" class="avatar sm rounded-circle" src="../assets/images/xs/avatar5.jpg">
                          </a>
                          <div class="media-body">
                            <small class="float-md-right">23h ago</small>
                            <span class="fw-bold">Monica Smith</span> love <span class="fw-bold">Kim Smith</span>. <br>
                            <small class="text-muted">2 days ago at 2:30 am - 11.06.2020</small>
                          </div>
                        </div>
                      </div>
                      <div class="feed-element">
                        <div class="media">
                          <a href="javascript:void(0)" class="me-3">
                            <img alt="image" class="avatar sm rounded-circle" src="../assets/images/xs/avatar6.jpg">
                          </a>
                          <div class="media-body">
                            <small class="float-md-right">46h ago</small>
                            <span class="fw-bold">Mike Loreipsum</span> started following <span class="fw-bold">Monica
                              Smith</span>. <br>
                            <small class="text-muted">3 days ago at 7:58 pm - 10.06.2020</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Project activity -->
                <div class="tab-pane" id="Last-activity" [ngClass]="{'show active': gridTab}">
                  <div class="card">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Status</th>
                          <th>Title</th>
                          <th>StartTime</th>
                          <th>EndTime</th>
                          <th>Comments</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span class="badge bg-primary"><i class="zmdi zmdi-check"></i> Completed</span>
                          </td>
                          <td>Create project in webapp</td>
                          <td>12.07.2020 10:10:1</td>
                          <td>14.07.2020 10:16:36</td>
                          <td>
                            <p class="small mb-0">
                              Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to
                              using 'Content here, content here', making it look like readable.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="badge bg-primary"><i class="zmdi zmdi-check"></i> Accepted</span>
                          </td>
                          <td>Various versions</td>
                          <td>12.07.2020 10:10:1</td>
                          <td>14.07.2020 10:16:36</td>
                          <td>
                            <p class="small mb-0">
                              Various versions have evolved over the years, sometimes by accident, sometimes on purpose
                              (injected humour and the like).
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="badge bg-primary"><i class="zmdi zmdi-check"></i> Sent</span>
                          </td>
                          <td>There are many variations</td>
                          <td>12.07.2020 10:10:1</td>
                          <td>14.07.2020 10:16:36</td>
                          <td>
                            <p class="small mb-0">
                              There are many variations of passages of Lorem Ipsum available, but the majority have
                              suffered alteration in some form, by injected humour, or randomised words which
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="badge bg-primary"><i class="zmdi zmdi-check"></i> Reported</span>
                          </td>
                          <td>Latin words</td>
                          <td>12.07.2020 10:10:1</td>
                          <td>14.07.2020 10:16:36</td>
                          <td>
                            <p class="small mb-0">
                              Latin words, combined with a handful of model sentence structures
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="badge bg-primary"><i class="zmdi zmdi-check"></i> Accepted</span>
                          </td>
                          <td>The generated Lorem</td>
                          <td>12.07.2020 10:10:1</td>
                          <td>14.07.2020 10:16:36</td>
                          <td>
                            <p class="small mb-0">
                              The generated Lorem Ipsum is therefore always free from repetition, injected humour, or
                              non-characteristic words etc.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="badge bg-primary"><i class="zmdi zmdi-check"></i> Sent</span>
                          </td>
                          <td>The first line</td>
                          <td>12.07.2020 10:10:1</td>
                          <td>14.07.2020 10:16:36</td>
                          <td>
                            <p class="small mb-0">
                              The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in
                              section
                              1.10.32.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="badge bg-primary"><i class="zmdi zmdi-check"></i> Reported</span>
                          </td>
                          <td>The standard chunk</td>
                          <td>12.07.2020 10:10:1</td>
                          <td>14.07.2020 10:16:36</td>
                          <td>
                            <p class="small mb-0">
                              The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those
                              interested.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="badge bg-primary"><i class="zmdi zmdi-check"></i> Completed</span>
                          </td>
                          <td>Lorem Ipsum is that</td>
                          <td>12.07.2020 10:10:1</td>
                          <td>14.07.2020 10:16:36</td>
                          <td>
                            <p class="small mb-0">
                              Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to
                              using 'Content here, content here', making it look like readable.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="badge bg-primary"><i class="zmdi zmdi-check"></i> Sent</span>
                          </td>
                          <td>Contrary to popular</td>
                          <td>12.07.2020 10:10:1</td>
                          <td>14.07.2020 10:16:36</td>
                          <td>
                            <p class="small mb-0">
                              Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece
                              of classical
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-lg-3 col-md-12">
              <div>
                <h5>Project description</h5>
                <p>It is a long established fact that a reader will be distracted by the readable content of a page when
                  looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal
                  distribution
                  of letters, as opposed to using 'Content here, content here', making it look like readable English.
                </p>
                <p class="fw-bold"><i class="zmdi zmdi-circle text-warning"></i> High priority</p>
                <div class="mt-4 mb-4">
                  <h5>Project tag</h5>
                  <a class="badge bg-primary" href="javascript:void(0)">Photoshop</a>
                  <a class="badge bg-secondary ml-1" href="javascript:void(0)">HTML, SCSS</a>
                  <a class="badge bg-warning ml-1  mt-1" href="javascript:void(0)">Laravel 7.0.0</a>
                  <a class="badge bg-info ml-1 mt-1" href="javascript:void(0)">ReactJs</a>
                </div>
                <h5>Project files</h5>
                <ul class="list-unstyled">
                  <li class="attachment mt-2">
                    <div class="media">
                      <div class="avatar me-2">
                        <div class="avatar rounded no-image orange">
                          <i class="zmdi zmdi-collection-pdf"></i>
                        </div>
                      </div>
                      <div class="media-body overflow-hidden">
                        <h6 class="text-truncate mb-0">Design file.pdf</h6>
                        <span class="file-size">2.7 mb</span>
                      </div>
                    </div>
                  </li>
                  <li class="attachment mt-2">
                    <div class="media">
                      <div class="avatar me-2">
                        <div class="avatar rounded no-image cyan">
                          <i class="zmdi zmdi-file"></i>
                        </div>
                      </div>
                      <div class="media-body overflow-hidden">
                        <h6 class="text-truncate mb-0">Design file.psd</h6>
                        <span class="file-size">22.5 mb</span>
                      </div>
                    </div>
                  </li>
                  <li class="attachment mt-2">
                    <div class="media">
                      <div class="avatar me-2">
                        <div class="avatar rounded no-image green">
                          <i class="zmdi zmdi-file-text"></i>
                        </div>
                      </div>
                      <div class="media-body overflow-hidden">
                        <h6 class="text-truncate mb-0">Project detail.doc</h6>
                        <span class="file-size">2.8 mb</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
